import type { Pead } from "epsm-api-types/models";
import { ONE_DAY_IN_MS } from "@/lib/utils";

const TIME_LINE_EXTRA_POINTS = 4; // we need to increase our time line by 4 point: we add -1, O at the beginning and add 2 extra points at the end.

export function getDayRange(pead: Pead | null) {
	if (!pead) return [];

	const earningDay = pead.earning_day?.getTime();
	const nextEarningDay = pead.next_earning_day?.getTime();

	const diffInDays = Math.ceil((nextEarningDay - earningDay) / ONE_DAY_IN_MS);

	const timeLine = Array.from(
		{ length: diffInDays + TIME_LINE_EXTRA_POINTS },
		(_, i) => i - 1,
	);

	return timeLine;
}
